import { useEffect, useState, type RefObject } from 'react'
import HeaderRenewer from '../../../../../apps/next/src/components/main/sections/Header'

type Props = {
	heroRef?: RefObject<HTMLDivElement>
	isStatic?: boolean
}

const Header = ({ heroRef, isStatic = false }: Props) => {
	const [isOverflowHeroImage, setIsOverflowHeroImage] = useState(false)

	useEffect(() => {
		if (isStatic || !heroRef?.current) return
		const checkOverflowHeroImage = () => {
			const scrollY = window.scrollY
			const heroY = heroRef.current?.clientHeight ?? 0
			const isOverflowHeroImage = scrollY > heroY
			setIsOverflowHeroImage(isOverflowHeroImage)
		}
		checkOverflowHeroImage()
		window.addEventListener('scroll', checkOverflowHeroImage)
		return () => {
			window.removeEventListener('scroll', checkOverflowHeroImage)
		}
	}, [heroRef, setIsOverflowHeroImage, isStatic])
	return (
		<HeaderRenewer
			isOverflowHeroImage={isOverflowHeroImage}
			headerBgColor={isOverflowHeroImage ? 'bg-singletons-white' : 'bg-singletons-black'}
			titleTextColor={(isOverflowHeroImage || isStatic) ? 'text-singletons-black' : 'text-singletons-white'}
		/>
	)
}

export default Header
